import { render } from "./UEWasteEditView.vue?vue&type=template&id=1515b0f2&scoped=true"
import script from "./UEWasteEditView.vue?vue&type=script&lang=js"
export * from "./UEWasteEditView.vue?vue&type=script&lang=js"

import "./UEWasteEditView.vue?vue&type=style&index=0&id=1515b0f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1515b0f2"]])

export default __exports__